export default __webpack_public_path__ + "static/media/england.c1c16478.svg";